import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.semantic.surface.muted};
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.span`
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const Value = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;
